<template>
  <div class="">
    <el-dialog v-model="dialog" title="Get Iframe Code" width="900" style="text-align: left;">
    <el-tabs
      type="border-card"
      @tab-click="trackTabChanged">
      <el-tab-pane label="Code Example">
        <h3>1. Add Iframe</h3>
        <div style="width: 100%; overflow: auto;overflow-y; hidden">
          <pre><code>{{ rawIframeCode }}</code></pre>
        </div>
        <h3>2. Add Javascript Code</h3>
        <div style="width: 100%; overflow: auto;overflow-y; hidden">
          <pre><code>{{ '<script type="text/javascript">' }}</code></pre>
          <pre><code>{{ getScriptCode }}</code></pre>
          <pre><code>{{ '</script>' }}</code></pre>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Test Result">
        <iframe
          style="margin:0 auto;display: block;width: 350px; height: 300px;"
          src="https://quoteform.nevadacoinmart.com/"
          id="iframe_quote_form"
          frameborder="0"
          scrolling="no"></iframe>
      </el-tab-pane>
    </el-tabs>
    </el-dialog>
    <el-row :gutter="24" style="margin: 0">
      <el-col :span="5">                       
        <el-input
          v-model="form.websiteUrl"
          placeholder="Website URL"
          >
        </el-input>
      </el-col>
      <el-col :span="3" style="padding: 0">
        <el-button
            type="primary"
            native-type="submit"
            style="width: 100%"
            @click="generateCode()">
            GENERATE CODE
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import validator from 'validator';

export default {
  name: 'MainApp',
  data: function () {
    return {
      dialog: false,
      rawIframeCode: '<iframe style="margin:0 auto;display: block;width: 350px; height: 300px;" src="https://quoteform.nevadacoinmart.com/" id="iframe_quote_form" frameborder="0" scrolling="no"></iframe>',
      form: {
        websiteUrl: ''
      }
    }
  },
  computed: {
    getScriptCode () {
      return  "const iframe = document.getElementById('iframe_quote_form');\n"+
              "iframe.onload = () => {\n"+
                "  iframe.contentWindow.postMessage(\"" + this.form.websiteUrl.toString() + "\", \"https://quoteform.nevadacoinmart.com/\");\n"+
              "};"
    }
  },
  methods: {
    generateCode () {
      let _vm = this
      if (!validator.isURL(_vm.form.websiteUrl)) {
        alert('Please add a website URL')
      } else {
        // process to site tracking
        _vm.dialog=true
      }
    },
    trackTabChanged () {
      let _vm = this
      var iframe = document.getElementById('iframe_quote_form');
      iframe.src = iframe.src + "?t=" + (Date.now());
      iframe.onload = () => {
        console.log("process send message")
        iframe.contentWindow.postMessage(_vm.form.websiteUrl.toString(), "https://quoteform.nevadacoinmart.com/");
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.el-dialog {
  padding: 0 !important;
}
.el-dialog__header {
    background: #138496;
    color: white !important;
    text-align: center !important;
}
.el-dialog .el-dialog__headerbtn {
    padding: 8px !important;
    background: #c30a24;
    border-radius: 61px;
    line-height: 0;
    margin-top: -20px;
    margin-right: -24px;
    opacity: 1;
    color: white;
    text-align: center;
    vertical-align: middle;
}
.el-dialog.el-dialog-bs-info {
    border: 5px solid #138496 !important;
    border-radius: 10px !important;
}
.el-dialog__headerbtn .el-dialog__close {
    color: white !important;
}
.el-dialog__header {
    padding: 6px 20px 10px !important;
}
.el-dialog__header h5 {
    margin-bottom: 0 !important;
    color: white !important;
}
.el-button--success {
    color: #FFF !important;
    background-color: #67C23A !important;
    border-color: #67C23A !important;
}
.el-input-group__append .el-button {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    padding: 13px 20px !important;
}
.el-dialog__body {
    padding: 15px 20px !important;
}
.el-dialog__footer {
    padding: 8px 0px !important;
    text-align: right !important;
}
.el-dialog.el-dialog-bs-info .el-dialog__footer {
    background: #138496;
}
</style>
